import React from 'react';
import './Rooms.css';

const Rooms = () => {
  const rooms = [
    {
      id: 1,
      type: 'Habitaciones Compartidas',
      quantity: '18 habitaciones',
      description: 'Habitaciones compartidas en modalidad de camarotes, perfectas para viajeros que buscan conocer gente nueva en un ambiente acogedor.',
      features: [
        'Camarotes cómodos',
        'Aire acondicionado',
        'Espacios limpios',
        'Ambiente social',
        'Lockers seguros'
      ],
      icon: '🛏️'
    },
    {
      id: 2,
      type: 'Habitaciones Privadas',
      quantity: '2 habitaciones',
      description: 'Habitaciones privadas ideales para quienes buscan mayor privacidad sin renunciar al ambiente familiar de nuestro hostal.',
      features: [
        'Privacidad total',
        'Aire acondicionado',
        'Cama confortable',
        'Espacio amplio',
        'Baño privado'
      ],
      icon: '🚪'
    }
  ];

  return (
    <section id="habitaciones" className="rooms">
      <div className="container">
        <div className="rooms-header">
          <h2 className="section-title">Nuestras Habitaciones</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Ubicadas en el piso superior de nuestra hermosa propiedad colonial
          </p>
        </div>

        <div className="rooms-grid">
          {rooms.map((room) => (
            <div key={room.id} className="room-card">
              <div className="room-icon">{room.icon}</div>
              <h3>{room.type}</h3>
              <p className="room-quantity">{room.quantity}</p>
              <p className="room-description">{room.description}</p>
              <div className="room-features">
                <h4>Características:</h4>
                <ul>
                  {room.features.map((feature, index) => (
                    <li key={index}>
                      <span className="check-icon">✓</span> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="rooms-details">
          <h3>Todas nuestras habitaciones incluyen:</h3>
          <div className="details-grid">
            <div className="detail-item">
              <span className="detail-icon">❄️</span>
              <p>Aire Acondicionado</p>
            </div>
            <div className="detail-item">
              <span className="detail-icon">💧</span>
              <p>Agua Caliente</p>
            </div>
            <div className="detail-item">
              <span className="detail-icon">🧹</span>
              <p>Limpieza Diaria</p>
            </div>
            <div className="detail-item">
              <span className="detail-icon">🪵</span>
              <p>Detalles de Madera Artesanal</p>
            </div>
          </div>
        </div>

        <div className="rooms-info">
          <div className="info-box">
            <h4>¿Por qué elegir nuestras habitaciones?</h4>
            <p>
              Cada habitación está diseñada para ofrecer el máximo confort. Con detalles
              de madera únicos y puertas artesanales diseñadas a mano, te sentirás
              transportado a otra época mientras disfrutas de todas las comodidades
              modernas.
            </p>
            <p>
              La arquitectura gótica de nuestro edificio colonial se complementa
              perfectamente con el ambiente cálido y acogedor que caracteriza a KAWILA.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rooms;
